




































import store from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/components/Modal.vue'; 
import Player from '@/view-models/Player.ts'; 
import { io } from "socket.io-client";
@Component({
  components: {
    Modal
  },
})
export default class Game extends Vue {
  public modal = true;
  public showVotes = false;
  public showCopiedToClipboard = false;

  public mounted() {
    if (this.joiningAGame()) {
      const socket = io(process.env.VUE_APP_SERVER, {
        query: {
          "roomId":this.$route.params.id
        }
      });
      store.commit('setSocket', socket);
    }

    store.state.socket.on('update', (players: Player[]) => {
      store.state.players = players;
    }); 

    store.state.socket.on('show', () => {
      this.showVotes = true;
    })

    store.state.socket.on('restart', () => {
      this.showVotes = false;
    })

    store.state.socket.on('ping', () => {
      store.state.socket.emit('pong');
    })
  }

  public showVotesClicked() {
    store.state.socket.emit('show');
  }

  public getPlayers() {
    return store.state.players;
  }

  public performVote(vote: string) {
    store.state.socket.emit('vote', vote);
  }

  public startNewGame() {
    store.state.socket.emit('restart');
  }

  public enteredName(name: string) {
    store.state.socket.emit('name', name);
    this.modal = false;
  }

  public playerHasVoted() {
     const players = store.state.players;
     if (players.filter(p => p.vote !== null && p.vote !== undefined).length > 0) {
       return true;
     }
     return false;
  }

  public copyToClipboard() {
    const tempInput = document.createElement("input");
    tempInput.value = window.location.href;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    this.showCopiedToClipboard = true;
    setTimeout(() => this.showCopiedToClipboard = false, 3000);
  }

  private joiningAGame() {
    const currentState = store.state.socket; 
    return currentState && Object.keys(currentState).length === 0 && currentState.constructor === Object
  }
}

